import React, { useState } from "react";
import { TrashIcon } from "@heroicons/react/24/outline";
import BillingSlideOver from "../../../../modal/BillingSlideOver";
import { useGetInvoicesDetailsQuery } from "../../../../../store/invoices";
import InvoiceTable from "../../../../tables/InvoiceTable";
import {
  useGetPaymentMehodsQuery,
  useSavePaymentMethodsMutation,
} from "../../../../../store/paymentCreation";
import Loader from "../../../../commons/Loader";
import { useEffect } from "react";
import { toast } from "react-toastify";
import DeleteRegionModal from "../../../../modal/DeleteRegionModal";
import { Link, useLocation } from "react-router-dom";
import { useGetAllUserInvoicesQuery } from "../../../../../store/admin/invoices";
import ProfessionalInvoiceTable from "../../../../tables/ProfessionalInvoiceTable";
import { useGetUserDetailsQuery } from "../../../../../store/admin/professionalUserInfo";

const ProfessionalBillingPayment = ({ isMobile }) => {
  const location = useLocation()
  const { professionalId } = location?.state ?? {};
  const [showSlide, setShowSlide] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDefaultPaymentModal, setShowDefaultPaymentModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const { data: userDetails } = useGetUserDetailsQuery(professionalId);

  const { data: invoicesDetail, isLoading: invoicesDetailLoader } =
    useGetAllUserInvoicesQuery({ id: professionalId });

  const {
    data: paymentDetails,
    isLoading: paymentDetailLoader,
    refetch: refetchPaymentDetails,
  } = useGetPaymentMehodsQuery();

  const [
    updatedPaymentMethod,
    {
      isSuccess: updatedPaymentMethodSuccess,
      isLoading: updatedPaymentMethodLoader,
      isError: updatedPaymentMethodError,
      data: updatedPaymentMethodData,
    },
  ] = useSavePaymentMethodsMutation();

  useEffect(() => {
    if (updatedPaymentMethodSuccess && !updatedPaymentMethodLoader) {
      setShowDefaultPaymentModal(false);
      setSelectedPayment(null);
      setShowDeleteModal(false);
      setSelectedPayment(null);
      toast.success(updatedPaymentMethodData.message);
      refetchPaymentDetails();
    }
    if (updatedPaymentMethodError && !updatedPaymentMethodLoader) {
      toast.error(updatedPaymentMethodData.message);
    }
  }, [updatedPaymentMethodSuccess, updatedPaymentMethodError]);

  const handleDeletePaymentMethod = () => {
    const params = {
      _method: "DELETE",
      id: selectedPayment.id,
    };
    updatedPaymentMethod(params);
  };

  const handleUpdatePaymentMethod = () => {
    const params = {
      _method: "PUT",
      id: selectedPayment.id,
    };
    updatedPaymentMethod(params);
  };

  const handleClose = () => {
    setShowDeleteModal(false);
    setShowDefaultPaymentModal(false);
  };

  return paymentDetailLoader || invoicesDetailLoader ? (
    <Loader isLoading={true} />
  ) : (
    <>
      <div>
        <div className="flex items-center justify-between gap-5 mb-[30px]">
          <h4 className="text-[22px] font-bold leading-[160%] text-customGray">
            Billing & Invoices
          </h4>
          {/* <PlusCircleIcon
            className="w-12 h-12 p-3 bg-primary text-white rounded-[10px] cursor-pointer"
            onClick={() => setShowSlide(true)}
          /> */}
        </div>
        {/* <div className="">
          {paymentDetails &&
            paymentDetails?.data?.map((payment, index) => {
              return (
                <div className="mb-[14px]">
                  <div className="payment-card border border-solid border-[#EBEFF3] p-5 rounded-md bg-white flex xl:items-center justify-between flex-col xl:flex-row gap-5 mb-[14px]">
                    <div className="form-group3 w-full">
                      <ul>
                        <li className="flex items-start md:items-center w-full justify-start md:justify-between flex-col md:flex-row gap-[12px]">
                          <input
                            type="radio"
                            id={payment.id}
                            name={payment.brand}
                            className="bg-white"
                            checked={payment.is_default}
                            onChange={() => {
                              setShowDefaultPaymentModal(true);
                              setSelectedPayment(payment);
                            }}
                          />
                          <div className="flex items-center gap-2.5">
                            <label
                              htmlFor={payment.id}
                              className="text-sm md:text-lg xl:text-xl font-bold leading-[160%] text-customGray"
                            >
                              <span className="capitalize">
                                {payment.display_brand}
                              </span>{" "}
                              ending in {payment.last4}
                            </label>
                          </div>
                          <div
                            className="check"
                            onClick={() => {
                              setShowDefaultPaymentModal(true);
                              setSelectedPayment(payment);
                            }}
                          ></div>
                          <div className="flex items-center gap-[30px] pl-0 md:pl-10 xl:p-0">
                            <div className="tooltip-icon relative inset-y-0 right-0 flex items-center h-6 my-auto cursor-pointer">
                              <button
                                className={`text-sm font-bold leading-[160%] text-[#485868] flex items-center gap-[6px] ${
                                  payment.is_default &&
                                  "pointer-events-none opacity-50"
                                }`}
                                onClick={() => {
                                  setShowDeleteModal(true);
                                  setSelectedPayment(payment);
                                }}
                              >
                                <TrashIcon className="w-5 h-5 text-[#485868]" />
                                Delete
                              </button>
                              {payment.is_default && (
                                <div
                                  className={`tooltip absolute ${
                                    isMobile ? "right-auto left-0" : "-right-2"
                                  } -bottom-[50px] bg-[#191549] rounded-md p-[10px] w-[280px] z-[2] invisible`}
                                >
                                  <div
                                    className={`w-4 h-4 rotate-45 rounded-tl-[4px] bg-[#191549] -mt-4 mr-auto md:mr-[14px] ml-[14px] md:ml-auto`}
                                  ></div>
                                  <p className="text-xs font-medium leading-[160%] text-[#F1F4F6]">
                                    You cannot delete the default payment
                                    method.
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              );
            })}
        </div> */}
        <div
          onClick={() => setShowSlide(true)}
          className="mb-[30px] inline-block text-primary text-base md:text-lg font-bold capitalize underline cursor-pointer"
        >
          add credit card
        </div>

        <>
          <div className="flex items-center justify-between gap-5 mb-5">
            <h6 className="text-lg font-bold leading-[160%] text-customGray">
              Transaction History
            </h6>
            {/* <Link
              to="/dashboard/settings/credit-limit"
              className="capitalize underline text-primary text-base md:text-lg font-bold leading-[160%] hover:underline"
            >
              modify credit pack
            </Link> */}
          </div>
          <ProfessionalInvoiceTable invoiceData={invoicesDetail?.data} userData={userDetails} />
        </>
        <BillingSlideOver show={showSlide} setShowSlide={setShowSlide} />
        <DeleteRegionModal
          isOpen={showDeleteModal}
          handleClose={handleClose}
          handleDelete={handleDeletePaymentMethod}
          text="Do you really want to delete this payment method?"
          loader={updatedPaymentMethodLoader}
        />
        <DeleteRegionModal
          isOpen={showDefaultPaymentModal}
          handleClose={handleClose}
          handleDelete={handleUpdatePaymentMethod}
          text={`Do you really want to set "${selectedPayment?.brand}" as default payment method?`}
          loader={updatedPaymentMethodLoader}
        />
      </div>
    </>
  );
};

export default ProfessionalBillingPayment;
